import React from 'react'
import { Form, Input, Button, message } from 'antd'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { resetPassword } from '../../reducers/authReducer'
import { LockOutlined } from '@ant-design/icons'

import {
  PageContainer,
  FormContainer,
  FormWrapper
} from '../Registeration/style'

const NewPasswordForm = ({ token }) => {
  const [form] = Form.useForm()
  const nav = useNavigate()
  const dispatch = useDispatch()

  const onFinish = async (values) => {
    const res = await dispatch(resetPassword(token, values.password))
    if (res.success) {
      nav('/login')
    }
  }

  return (
    <PageContainer>
      <FormContainer>
        <FormWrapper>
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '15px'
              }}
            >
              <h2>Create New Password</h2>
            </div>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please enter your password'
                },
                {
                  min: 8,
                  message: 'Password must contain at least 8 characters'
                }
              ]}
            >
              <Input.Password
                placeholder="New password"
                prefix={<LockOutlined />}
              />
            </Form.Item>
            <Form.Item
              name="passwordConfirm"
              dependencies={['password']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password'
                },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve()
                    }

                    return Promise.reject(
                      'The password that you entered do not match'
                    )
                  }
                })
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Confirm password"
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" block>
              Reset Password
            </Button>
          </Form>
        </FormWrapper>
      </FormContainer>
    </PageContainer>
  )
}

export default NewPasswordForm
